import { render, staticRenderFns } from "./SubCategorySelector.vue?vue&type=template&id=09ec5ce3&scoped=true"
import script from "./SubCategorySelector.vue?vue&type=script&lang=js"
export * from "./SubCategorySelector.vue?vue&type=script&lang=js"
import style0 from "./SubCategorySelector.vue?vue&type=style&index=0&id=09ec5ce3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ec5ce3",
  null
  
)

export default component.exports